import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import { RoomOutputDTO, TimeEventOutputDTO } from "@kalyzee/kast-web-sdk/http";
import { getRoom, getTimeEvents } from "./thunks";

export interface RoomState {
  room: RoomOutputDTO | undefined;
  timeEvents: TimeEventOutputDTO[] | undefined;
}

const initialState: RoomState = {
  room: undefined,
  timeEvents: undefined,
};

export const roomSlice = createSlice({
  name: "room",
  initialState,
  reducers: {
    setRoom: (state, action: PayloadAction<RoomOutputDTO | undefined>) => {
      state.room = action.payload;
    }
  },
  extraReducers: (builder) => {
    builder
      .addCase(getTimeEvents.fulfilled, (state, action) => {
        state.timeEvents = action.payload;
      })
      .addCase(getRoom.fulfilled, (state, action) => {
        state.room = action.payload;
      });
  },
});

export const {
  setRoom
} = roomSlice.actions;

const roomReducer = roomSlice.reducer;
export default roomReducer;
